import { css, CSSResult } from 'lit'
import { csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const cscProductDescription = {
  color: css`var(--csc-product-description-color, var(--cs-font-body-color, ${csColorText.body}))`,
  fontFamily: css`var(--csc-product-description-font-family, var(--cs-font-body-font-family, var(--cs-font-family-body, Roboto, Arial, sans-serif)))`,
  fontSize: css`var(--csc-product-description-font-size, var(--cs-font-body-font-size, 16px))`,
  fontSizeMobile: css`var(--csc-product-description-font-size-mobile, var(--cs-font-body-font-size-mobile, 16px))`,
  fontWeight: css`var(--csc-product-description-font-weight, var(--cs-font-body-font-weight, 400))`,
  lineHeight: css`var(--csc-product-description-line-height, var(--cs-font-body-line-height, 1.5))`,
  expandableHeight: css`var(--csc-product-description-expandable-content-height, 100px)`,
  previewHeight: css`var(--csc-product-description-preview-height, 100px)`,
  previewFadeHeight: css`var(--csc-product-description-preview-fade-height, 40px)`,
}

export const style: CSSResult = css`
  cse-expandable {
    --cse-expandable-content-height: ${cscProductDescription.expandableHeight};
  }

  .description {
    color: ${cscProductDescription.color};
    font-family: ${cscProductDescription.fontFamily};
    font-size: ${cscProductDescription.fontSizeMobile};
    font-weight: ${cscProductDescription.fontWeight};
    line-height: ${cscProductDescription.lineHeight};
  }

  .description > :first-child {
    margin-top: 0;
  }

  .description > :last-child {
    margin-bottom: 0;
  }

  .description--preview {
    max-height: ${cscProductDescription.previewHeight};
    overflow: hidden;
    mask-image: linear-gradient(
      to bottom,
      #000 calc(${cscProductDescription.previewHeight} - ${cscProductDescription.previewFadeHeight}),
      transparent ${cscProductDescription.previewHeight}
    );
  }

  .read-more {
    display: inline-block;
    margin-top: ${csSpacing.spacing02};
  }

  @media (min-width: 768px) {
    .description {
      font-size: ${cscProductDescription.fontSize};
    }
  }
`
